export * from "./types.js";
export * from "./copy.js";
export {
  borrowingPower,
  repaymentStress,
  assertNoCreditHandoff,
  monthlyRepaymentPI,
  monthlyRepaymentIO,
} from "./calculate.js";
export { settings2026_02_01 } from "./settings-2026-02-01.js";

import type { BorrowingPowerRuleSet } from "./types.js";
import { settings2026_02_01 } from "./settings-2026-02-01.js";

/**
 * Registry of borrowing-power rulesets by APRA-settings effective date. These
 * are date-keyed (APRA macroprudential settings change on APRA's schedule, NOT
 * the financial year). Historical settings stay registered so a re-run resolves
 * against the settings in force then.
 */
export const BORROWING_POWER_RULESETS: Record<string, BorrowingPowerRuleSet> = {
  "2026-02-01": settings2026_02_01,
};

/** Resolve the borrowing-power ruleset for a settings date, or throw if unknown. */
export function borrowingPowerRulesFor(
  settingsDate: string,
): BorrowingPowerRuleSet {
  const rules = BORROWING_POWER_RULESETS[settingsDate];
  if (!rules) {
    throw new Error(
      `no borrowing-power ruleset registered for settings date ${settingsDate}`,
    );
  }
  return rules;
}

/** Most recent borrowing-power settings — the default for live calcs. */
export const BORROWING_POWER_CURRENT_SETTINGS = "2026-02-01";
